module.exports = __webpack_public_path__ + "img/77-b6eac2.png";